import Icon from '../components/Icon.vue'

Icon.register({
  dizzy: {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM152 214.6l28.7 28.7c14.7 14.8 37.8-7.4 22.6-22.6l-28.7-28.7 28.7-28.7c15-14.9-7.6-37.6-22.6-22.6l-28.7 28.7-28.7-28.7c-14.9-15-37.6 7.6-22.6 22.6l28.7 28.7-28.7 28.7c-15.2 15.1 7.8 37.4 22.6 22.6zM248 416c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zM395.3 220.7l-28.7-28.7 28.7-28.7c15-14.9-7.6-37.6-22.6-22.6l-28.7 28.7-28.7-28.7c-14.9-15-37.6 7.6-22.6 22.6l28.7 28.7-28.7 28.7c-15.2 15.1 7.8 37.4 22.6 22.6l28.7-28.7 28.7 28.7c14.7 14.8 37.8-7.4 22.6-22.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/dizzy.js
// module id = 1273
// module chunks = 0